import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Home from '@/views/Home.vue';
import Login from '@/views/Login.vue';
import { store } from '@/store';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      isAuthRoute: true
    }
  },
  { path: '/:pathMatch(.*)*', redirect: { path: '/', replace: true } }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Middleware per gestire l'autenticazione
router.beforeEach((to, from, next) => {
	// Controlla se la view necessita di autenticazione, e nel caso se si è autenticati
	if (
		to.matched.some((record) => record.meta.requiresAuth) &&
		(!store.getters.isLogged ||
			store.getters.isLogged === false)
	) {
    router.push("/login");
    next();
    return;
	}

	if (
		to.matched.some((record) => record.meta.isAuthRoute) &&
		(store.getters.isLogged)
	) {
    router.push("/");
	  next();
    return;
	}

  next();

})


export default router
